import React, { useRef, useLayoutEffect, useState } from 'react';
import clsx from 'clsx';

import { Tooltip } from '@ovpn-ui/core';

import { TextOverflowWrapper } from './TextOverflow.styles';
import { TextOverflowProps } from './TextOverflow.types';

export function TextOverflow({ children, content, tooltipProps, ...props }: TextOverflowProps) {
    const textRef = useRef<HTMLSpanElement>();
    const [withTooltip, setTooltip] = useState(false);
    const subject = content || children;

    useLayoutEffect(() => {
        if (textRef.current) {
            const overflows = textRef.current.offsetWidth < textRef.current.scrollWidth;
            setTooltip(overflows);
        }
    }, [subject]);

    if (!subject) {
        return null;
    }

    const trigger = (
        <TextOverflowWrapper {...props} ref={textRef}>
            {children}
        </TextOverflowWrapper>
    );

    if (withTooltip) {
        return (
            <Tooltip
                trigger={trigger}
                interactive
                {...tooltipProps}
                className={clsx('break-word', tooltipProps?.className)}
            >
                {children}
            </Tooltip>
        );
    }

    return trigger;
}
